import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';


const Dist_Month_RO_Report_data = async (params) => {  

    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/AnnavitranTransInt`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }  

    return response.json();
};

const AnnavitranTransReport = ({ month, year}) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); 

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Dist_Month_RO_Report_data({month,year});

                 setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
                
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth' , block: 'center'});
        }
    }, [loading, error, reportData]);

    
    if (loading) {
        return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
            <CircularProgress />
        </Box></div>
    }
    if (error) {
        return <div class="mainhead" align="center">
        Internal Error 
        </div>
      }
    // if (reportData.length === 0) {
    //     return <div class="mainhead" align="center">
    //     No data found 
    // </div>
    //   }  

    if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return <div className="mainhead" align="center">
        No data found
    </div>
}
      
           const totals = reportData.reduce(
                 (acc, item) => {
                    acc.aay_b_tr += (item.aay_b_tr)||0;
                    acc.aay_b_rc += (item.aay_b_rc)||0;
                    acc.aay_i_tr += (item.aay_i_tr)||0;
                    acc.aay_i_rc += (item.aay_i_rc)||0;
                    acc.aay_o_tr += (item.aay_o_tr)||0;

                    acc.aay_o_rc += (item.aay_o_rc)||0;
                    acc.phh_b_tr += (item.phh_b_tr)||0;
                    acc.phh_b_rc += (item.phh_b_rc)||0;

                    acc.phh_i_tr += (item.phh_i_tr)||0;
                    acc.phh_i_rc += (item.phh_i_rc)||0;
                    acc.phh_o_tr += (item.phh_o_tr)||0;
                    acc.phh_o_rc += (item.phh_o_rc)||0;
                    acc.non_b_tr += (item.non_b_tr)||0;
                    acc.non_b_rc += (item.non_b_rc)||0;
                    acc.non_i_tr += (item.non_i_tr)||0;
                    acc.non_i_rc += (item.non_i_rc)||0;
                    acc.non_o_tr += (item.non_o_tr)||0;
                    acc.non_o_rc += (item.non_o_rc)||0;
                  
          return acc;
        },
        {
            aay_b_tr :0,
            aay_b_rc :0, 
            aay_i_tr :0,
            aay_i_rc :0, 
            aay_o_tr :0,
            aay_o_rc :0, 
            phh_b_tr :0,
            phh_b_rc :0,
            phh_i_tr :0,
            phh_i_rc :0,
            phh_o_tr :0,
            phh_o_rc :0,
            non_b_tr :0,
            non_b_rc :0,
            non_i_tr :0, 
            non_i_rc :0,      
            non_i_tr :0,
            non_i_rc :0

              
        }
      );
       
    return (
        <> 
            <table  id="myTable" align="center" width="100%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={20}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                         <td rowSpan={4}>Sl No</td>
                         <td rowSpan={4}>District</td> 
                    </tr>

                    <tr class="tableheader">
                        <td colspan={6}>AAY (in Kgs)</td>
                        <td colspan={6}>PHH (in Kgs)</td>
                        <td colspan={6}>Non NFSA (in Kgs)</td>
                    </tr>



                    <tr class="tableheader">
                        <td colspan={2}>FINGER</td>
                        <td colspan={2}>IRIS</td>
                        <td colspan={2}>Others </td>
                        <td colspan={2}>FINGER</td>
                        <td colspan={2}>IRIS</td>
                        <td colspan={2}>Others</td>
                        <td colspan={2}>FINGER</td>
                        <td colspan={2}>IRIS</td>
                        <td colspan={2}>Others</td>
                    </tr>

      <tr class="tableheader">
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
            <td>Trans</td>
            <td>Cards</td>
        </tr>

                   
                </thead>
                <tbody>
                    { 
                        reportData.map((item, index) => (
                            <tr key={item.dfso_nm}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ textAlign: 'left' }}> {item.dfso_nm}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_b_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_b_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_i_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_i_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_o_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.aay_o_rc}</td>

                                    <td style={{ textAlign: 'right' }}>{item.phh_b_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_b_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_i_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_i_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_o_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.phh_o_rc}</td>

                                    <td style={{ textAlign: 'right' }}>{item.non_b_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.non_b_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.non_i_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.non_i_rc}</td>
                                    <td style={{ textAlign: 'right' }}>{item.non_o_tr}</td>
                                    <td style={{ textAlign: 'right' }}>{item.non_o_rc}</td>
                                
                            </tr>
                        ))
                     }
                    <tr className="tableheader">
                      <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_b_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_b_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_i_tr||0)}</td>    
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_i_rc||0)}</td>     
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_o_tr||0)}</td>                                           
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.aay_o_rc||0)}</td>                                          
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_b_tr||0)}</td>    
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_b_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_i_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_i_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_o_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.phh_o_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_b_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_b_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_i_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_i_rc||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_o_tr||0)}</td>
                      <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{(totals.non_o_rc||0)}</td>
                             
                   </tr>  
                </tbody>
           </table>
            <br /><br /> <br /><br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default AnnavitranTransReport;
